module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-site-editor"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('erco-options-group', {
    attrs: {
      "label": "Sprache",
      "size": "sm",
      "options": _vm.langs
    },
    on: {
      "click": _vm.handleLangClick
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('erco-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "label": "Paginierung",
      "size": "sm",
      "items": _vm.pagination.items,
      "currentItemIndex": _vm.pagination.selectedIndex
    },
    on: {
      "change": _vm.handlePaginationChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "label": "Abstand unten",
      "size": "sm",
      "items": _vm.distanceBelow.items,
      "currentItemIndex": _vm.distanceBelow.selectedIndex
    },
    on: {
      "change": _vm.handleDistanceBelowChange
    }
  }), _vm._v(" "), _c('erco-dropdown', {
    staticClass: "mr-3",
    attrs: {
      "label": "Hintergrund",
      "size": "sm",
      "items": _vm.backgroundType.items,
      "currentItemIndex": _vm.backgroundType.selectedIndex
    },
    on: {
      "change": _vm.handleBackgroundTypeChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row row-distance-above"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-input', {
    attrs: {
      "label": "Überschrift",
      "text": _vm.title
    },
    on: {
      "change": _vm.handleTitleChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-area', {
    staticClass: "image-subtitle",
    attrs: {
      "label": "Bildunterschrift",
      "text": _vm.imageSubtitle
    },
    on: {
      "change": _vm.handleImageSubtitleChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "row subtitle-row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-input', {
    attrs: {
      "label": "Überschrift",
      "text": _vm.subtitle
    },
    on: {
      "change": _vm.handleSubtitleChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row text-row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('erco-text-area', {
    staticClass: "text-textarea",
    attrs: {
      "label": "Text",
      "text": _vm.text
    },
    on: {
      "change": _vm.handleTextChange
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "multiform-items"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Multiform")]), _vm._v(" "), _vm._l((_vm.multiformItems), function(multiformItem) {
    return _c('div', {
      key: multiformItem.id,
      class: ['multiform-item', multiformItem.type]
    }, [(multiformItem.type === 'text') ? _c('erco-text-input', {
      attrs: {
        "label": multiformItem.label,
        "text": multiformItem.values.value
      },
      on: {
        "change": function($event) {
          _vm.handleMultiformInputChange(_vm.index, $event)
        }
      }
    }) : (multiformItem.type === 'image') ? _c('erco-text-input', {
      attrs: {
        "label": multiformItem.label,
        "text": multiformItem.values.value
      },
      on: {
        "change": function($event) {
          _vm.handleMultiformInputChange(multiformItem, $event)
        }
      }
    }) : _c('div', [_vm._v("\n\t\t    \tUnbekannter Item-Typ: " + _vm._s(multiformItem.type) + "\n\t\t    ")])], 1)
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 img-editor"
  }, [_c('label', [_c('span', {
    staticClass: "label text-muted",
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Bild")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "margin-top": "0.4rem"
    },
    attrs: {
      "src": "http://placehold.it/600x600"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-83810df6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/molecules/ErcoSidebar/SiteEditor.vue
// module id = 643
// module chunks = 0